import { render, staticRenderFns } from "./screenshot.md?vue&type=template&id=0d0324c8"
import script from "./screenshot.md?vue&type=script&lang=js"
export * from "./screenshot.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports